import { render, staticRenderFns } from "./ShowMaterial.vue?vue&type=template&id=0953856e&scoped=true&"
import script from "./ShowMaterial.vue?vue&type=script&lang=js&"
export * from "./ShowMaterial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0953856e",
  null
  
)

export default component.exports